import { render, staticRenderFns } from "./MenuNoticeDialog.vue?vue&type=template&id=2d974a10&scoped=true&"
import script from "./MenuNoticeDialog.vue?vue&type=script&lang=js&"
export * from "./MenuNoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./MenuNoticeDialog.vue?vue&type=style&index=0&id=2d974a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d974a10",
  null
  
)

export default component.exports